<template>
  <PageHeader
    logo-url="/img/logo-galileo-color-2x.png"
    app-name="galileo_forms_web"
    :should-hide-brand-logo="true"
    :app-iconic-logo="''"
    :userName="userName"
  >
    <template slot="account-links-bottom">
      <CDropdownHeader class="font-weight-bold" v-if="!isAuthenticated">
        <CLink to="/account/login">
          <CIcon :content="$options.freeSet.cilUser"></CIcon>
          Log In
        </CLink>
      </CDropdownHeader>
      <CDropdownHeader class="font-weight-bold" v-else @click="logoutUser">
        <CIcon :content="$options.freeSet.cilLockLocked"></CIcon>
        Log out
      </CDropdownHeader>
    </template>
  </PageHeader>
</template>
<script>
  import {freeSet} from "@coreui/icons";
  import {ActiveUser} from "@/services/user";

  export default {
    name: 'ThePageHeader',
    freeSet,
    data() {
      return {
        isAuthenticated: ActiveUser.getToken(),
        userName: null,
      }
    },
    async mounted(){
      const userMeta = await ActiveUser.getMeta();
      this.userName = userMeta?.email;
    },
    methods: {
      logoutUser() {
        ActiveUser.clear()
        this.$router.replace('/account/login')
      },
    }
  };
</script>
